import { appSetLoading } from "store/actions/appAction";
import { setTableData } from "store/actions/dataTableAction";
import { setUserCard } from "store/actions/reportAction";
import axios from "../../axios/axios";
import { errorDispatcher, setSelectItemLabels } from "helpers";
import { AppDispatch } from "store/store";

interface GetUserCardEntity {
  dispatch: AppDispatch;
  pagination?: any;
  token?: string;
  options?: any;
  sort?: any;
  search?: any;
  params?: any;
  tab: string;
  userId?: number;
}

export function apiGetUserCard(props: GetUserCardEntity) {
  return new Promise<any>((resolve, reject) => {
    const { options, pagination, search, sort, tab, token, userId, dispatch } = props;
    const params = { ...pagination, ...sort, ...search, ...props.params, ...options, userId };
    const data = params

    let url = `/reports/user/${tab}`;
    if (!userId) {
      return dispatch(setTableData({ error: "برای مشاهده این گزارش یک کالا انتخاب کنید" }, pagination));
    }

    dispatch(appSetLoading());
    axios
      .post(url, data, { headers: { Authorization: `Bearer ${token}` }, params })
      .then((response) => {
        const paginate = response.data.paginate;
        const user = response.data?.user;
        const key = tab.slice(0, -1);
        const userLogs: any[] = response.data?.userLogs;
        // const items = userLogs?.flatMap((x) => x[key] || []);
        if (paginate && userLogs) dispatch(setTableData(userLogs, paginate));
        dispatch(appSetLoading(false));
        resolve(response.data);
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
        reject(error);
      });
  });
}
